import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import CreateIcon from "@mui/icons-material/Create"
import { useDispatch, useSelector } from "react-redux"
import classes from "./menu.module.scss"
import MenuListContainer from "../../../../components/menuListContainer/index"
import {
  getBarMenuPeriodAction,
  getMenuPeriodAction,
  exportMenuListAction,
  getUploadStatusAction,
  getWineMenuPeriodAction,
  moveFoodItemCategoryAction,
  reorderMenuItemsAction,
  reorderMenuCategoriesAction
} from "redux/marketing/actions"
import CommonModal from "components/CommonModal"
import { Box, Grid, InputAdornment, Typography, useTheme } from "@mui/material"
import { useHistory } from "react-router-dom"
import { marketingActions } from "redux/marketing/slice/user"
import MenuNavBar from "components/menuNavBar"
import SubMenuBar from "components/subMenuBar"
import WineListItems from "components/WineListItems"
import BarListItems from "components/BarListItem"
import {
  getMenuSubCategoryAction,
  getNewSpiritCountAction,
  getSpiritCMSAction
} from "redux/marketing/actions/user"
import SpiritsMenuListContainer from "components/spiritsMenuListConatiner"
import SpiritsSubMenuBar from "components/SpiritsSubMenuBar"
import DMV_SpiritSummary from "components/DMVSpiritSummary"
import ImportSpiritsModal from "components/ImportSpirits"
import UploadAddMenuModal from "./BulkUpload/UploadAddMenuModal"
import { useDebounce } from "hooks/utils"
import SearchTextField from "components/StyledComponents/SearchTextField"
import SearchIcon from "@mui/icons-material/Search"
import WineBottleListItems from "components/WineBottleListItems"
import AddMenuItems from "./AddMenuItems"
import DMVAddMenuItems from "pages/private/DVM_Console/DMV_Menu/AddDMVMenuItems"
import MenuDndBoard from "components/MenuDndBoard"
import ReorderCategoriesModal from "components/ReorderCategoriesModal"

const menuText = {
  BARMENU: "bar menu",
  WINEBAR: "wine by glass",
  WINEBOTTLE: "wine by bottle",
  DINNER: "dinner",
  LUNCH: "lunch",
  BRUNCH: "brunch",
  BREAKFAST: "breakfast",
  SPIRITS: "spirits",
  SPECIALS: "specials"
}

// Exact meal_period strings the ordering API switches on. Food meal-periods are
// omitted — they map to the API's "anything else" → FoodItem case (sent as-is).
const MEAL_PERIOD_API = {
  [menuText.BARMENU]: "Bar Menu",
  [menuText.WINEBAR]: "Wine By Glass",
  [menuText.WINEBOTTLE]: "Wine By Bottle"
}

function Menu() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const dispatch = useDispatch()
  const history = useHistory()
  const theme = useTheme()
  const { linkCategory } = useSelector((state) => state?.marketing?.menu || {})
  const { menuPeriod, barMenuPeriod, wineMenuPeriod, spiritData, menuSubCategory } = useSelector(
    (state) => state?.marketing?.menu || []
  )
  const { isLoading } = useSelector((store) => store.app)
  const { menuCategory, SpiritSubMenu } = useSelector((state) => state.dmv)
  const [importSpiritModal, setImportSpiritModal] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const [menuItems, setMenuItems] = useState(menuPeriod)
  const [barItems, setBarItems] = useState(barMenuPeriod)
  const [wineItems, setWineItems] = useState(wineMenuPeriod)
  const [spiritItems, setSpiritItems] = useState(spiritData)
  // Hosts the item edit form so items can be edited directly from this
  // (summary) view via double-click, without entering the Edit Menu screen.
  const [menuItemsModal, setMenuItemsModal] = useState(false)
  const [isEditModalItem, setIsEditModalItem] = useState(false)
  const [reorderCategoriesOpen, setReorderCategoriesOpen] = useState(false)

  function handleCloseMenuItems() {
    setMenuItemsModal(false)
    setIsEditModalItem(false)
    dispatch(marketingActions.setFoodItemsDetail({}))
  }

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  // Drag-and-drop reorder/move (same as the Edit screen). Updates local state
  // optimistically; the saga re-fetches to reflect the server's authoritative order.
  const makeListDragEndHandler = (items, setItems, mealPeriod) => (result) => {
    const { source, destination, draggableId } = result
    if (!destination) return
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return
    }
    const next = items.map((cat) => ({ ...cat, food_list: [...(cat?.food_list || [])] }))
    const from = next.find((c) => String(c.food_category_id) === source.droppableId)
    const to = next.find((c) => String(c.food_category_id) === destination.droppableId)
    if (!from || !to) return
    const [moved] = from.food_list.splice(source.index, 1)
    if (!moved) return
    to.food_list.splice(destination.index, 0, moved)
    setItems(next)

    if (source.droppableId === destination.droppableId) {
      dispatch(
        reorderMenuItemsAction({
          payload: {
            meal_period: mealPeriod,
            category_id: destination.droppableId,
            item_orders: to.food_list.map((it) => ({ id: it.id }))
          }
        })
      )
    } else {
      dispatch(
        moveFoodItemCategoryAction({
          payload: {
            meal_period: mealPeriod,
            item_id: draggableId,
            target_category_id: destination.droppableId,
            target_order: destination.index + 1
          }
        })
      )
    }
  }

  const getCurrentCategories = () => {
    if (linkCategory?.item === menuText.BARMENU) return barItems
    if (linkCategory?.item === menuText.WINEBAR || linkCategory?.item === menuText.WINEBOTTLE)
      return wineItems
    return menuItems
  }

  const handleCategoryReorderSave = (orderedCategories) => {
    const mealPeriod = MEAL_PERIOD_API[linkCategory?.item] || linkCategory?.item
    dispatch(
      reorderMenuCategoriesAction({
        payload: {
          meal_period: mealPeriod,
          category_orders: orderedCategories.map((c) => c.food_category_id)
        }
      })
    )
  }

  const handleRouting = () => {
    const itemsLink = {
      item: linkCategory?.item,
      category: linkCategory?.category,
      list: "Detailed View"
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
    history.push("/marketing/dashboard/explore-menu/edit")
  }

  const handleArchivedRouting = () => {
    dispatch(marketingActions.setArchivedMenu(true))
    history.push("/marketing/dashboard/explore-menu/archived-items")
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Menu"
  }, [])

  useEffect(() => {
    if (linkCategory?.item === menuText.BARMENU) {
      dispatch(getBarMenuPeriodAction())
    } else if (
      linkCategory?.item === menuText.WINEBAR ||
      linkCategory?.item === menuText.WINEBOTTLE
    ) {
      dispatch(getWineMenuPeriodAction())
    } else if (linkCategory?.item === menuText.SPIRITS) {
      dispatch(getSpiritCMSAction())
      dispatch(getNewSpiritCountAction())
    } else {
      dispatch(getMenuSubCategoryAction())
      dispatch(getMenuPeriodAction())
    }
    setSearchValue("")
  }, [linkCategory?.item, linkCategory?.category])

  function handleImportSpirit() {
    setImportSpiritModal(true)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const handleReviewMenu = () => {
    history.push("/marketing/dashboard/explore-menu/review-menu")
  }

  const handleReviewMenuClick = () => {
    dispatch(
      getUploadStatusAction({
        callback: (status) => {
          if (status === "COMPLETED" || status === "not found" || status === "FAILED") {
            handleReviewMenu()
          } else {
            setStatusModalOpen(true)
          }
        }
      })
    )
  }

  const handleExportMenuList = () => {
    dispatch(exportMenuListAction())
  }

  const isExportDisabled = () => {
    switch (linkCategory?.item) {
      case menuText.BARMENU:
        return !barItems || barItems.length === 0
      case menuText.WINEBAR:
      case menuText.WINEBOTTLE:
        return !wineItems || wineItems.length === 0
      case menuText.SPIRITS:
        return !spiritItems || spiritItems.length === 0
      default:
        return !menuItems || menuItems.length === 0
    }
  }

  function filterResults(searchQuery, results, menuType) {
    const trimmedQuery = searchQuery.trim().toLowerCase()

    if (!trimmedQuery) {
      return results
    }

    const isSpiritsMenu = menuType === menuText.SPIRITS
    const listKey = isSpiritsMenu ? "spirit_list" : "food_list"
    const categoryKey = isSpiritsMenu ? "spirit_category" : "food_category"

    return results
      ?.map((period) => {
        const category = period[categoryKey]?.toLowerCase()
        const isCategoryMatch = category.includes(trimmedQuery)

        // If the search query partially matches the category, return all items in that category
        if (isCategoryMatch) {
          return period
        }

        // Filter items by name or by ingredients
        const filteredList = period[listKey]?.filter((item) => {
          const nameMatch = item?.name?.toLowerCase().includes(trimmedQuery)
          let fieldMatches
          if (isSpiritsMenu) {
            const searchableFields = [
              "description",
              "origin",
              "unique_facts",
              "ingredient",
              "nose",
              "palate",
              "finish",
              "distillation",
              "aging",
              "bottling"
            ]

            fieldMatches = searchableFields.some((field) => {
              if (typeof item[field] === "string") {
                return item[field].toLowerCase().includes(trimmedQuery)
              }

              if (Array.isArray(item[field])) {
                return item[field].some((value) => {
                  if (typeof value === "string") {
                    return value.toLowerCase().includes(trimmedQuery)
                  } else if (typeof value === "object" && value?.fact) {
                    return value.fact.toLowerCase().includes(trimmedQuery)
                  } else if (typeof value === "object" && value?.name) {
                    return value.name.toLowerCase().includes(trimmedQuery)
                  }
                  return false
                })
              }
              return false
            })
          }

          // Dynamically search in the data_to_display fields
          const dataFieldMatch = item?.data_to_display?.some((field) => {
            const fieldValue = field?.value

            if (typeof fieldValue === "string") {
              return fieldValue.toLowerCase().includes(trimmedQuery)
            }

            // If the value is an array, search within the array elements (e.g., allergens or ingredients)
            if (Array.isArray(fieldValue)) {
              return fieldValue.some((value) => {
                if (typeof value === "string") {
                  return value.toLowerCase().includes(trimmedQuery)
                } else if (typeof value === "object" && value?.name) {
                  return value.name.toLowerCase().includes(trimmedQuery)
                }
                return false
              })
            }

            if (typeof fieldValue === "object" && fieldValue?.name) {
              return fieldValue.name.toLowerCase().includes(trimmedQuery)
            }

            return false
          })

          return nameMatch || dataFieldMatch || fieldMatches
        })

        return filteredList?.length > 0 ? { ...period, [listKey]: filteredList } : null
      })
      .filter(Boolean)
      .sort((a, b) => {
        const categoryA = a[categoryKey].toLowerCase()
        const categoryB = b[categoryKey].toLowerCase()

        // Sort based on how closely the category matches the query
        if (categoryA === trimmedQuery) return -1
        if (categoryB === trimmedQuery) return 1

        if (categoryA.startsWith(trimmedQuery) && !categoryB.startsWith(trimmedQuery)) return -1
        if (!categoryA.startsWith(trimmedQuery) && categoryB.startsWith(trimmedQuery)) return 1

        return categoryA.localeCompare(categoryB)
      })
  }

  useEffect(() => {
    const menuMap = {
      [menuText.BARMENU]: {
        data: barMenuPeriod,
        setFunction: setBarItems
      },
      [menuText.WINEBAR]: {
        data: wineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.WINEBOTTLE]: {
        data: wineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.SPIRITS]: {
        data: spiritData,
        setFunction: setSpiritItems
      },
      default: {
        data: menuPeriod,
        setFunction: setMenuItems
      }
    }

    const { data, setFunction } = menuMap[linkCategory?.item] || menuMap.default
    const filteredResults = filterResults(debouncedSearchTerm, data, linkCategory?.item)
    setFunction(filteredResults)
  }, [
    barMenuPeriod,
    wineMenuPeriod,
    spiritData,
    menuPeriod,
    linkCategory?.item,
    menuCategory?.name,
    linkCategory?.category,
    debouncedSearchTerm
  ])

  return (
    <Fragment>
      {linkCategory?.item === menuText.SPIRITS ? (
        <DMVAddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
          isCMS={true}
        />
      ) : (
        <AddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
        />
      )}
      <UploadAddMenuModal open={modalOpen} onClose={handleClose} />
      {importSpiritModal && (
        <ImportSpiritsModal open={importSpiritModal} onClose={() => setImportSpiritModal(false)} />
      )}
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header title={`Menu`} breadCrumbs={breadCrumbs}>
              <Grid container spacing={2}>
                {linkCategory?.item !== menuText.SPIRITS && (
                  <Grid item>
                    <AppButton
                      className={classes.exportButton}
                      variant="contained"
                      onClick={handleExportMenuList}
                      disabled={isExportDisabled()}>
                      Export
                    </AppButton>
                  </Grid>
                )}
                <Grid item>
                  <AppButton variant="contained" onClick={handleReviewMenuClick}>
                    Review Menu
                  </AppButton>
                </Grid>
                <Grid item>
                  {linkCategory?.item !== menuText.SPIRITS ? (
                    <AppButton variant="contained" onClick={() => setModalOpen(true)}>
                      + Bulk Upload
                    </AppButton>
                  ) : null}
                </Grid>
                <Grid item>
                  <AppButton variant="contained" onClick={handleArchivedRouting}>
                    Archived Items
                  </AppButton>
                </Grid>
                {linkCategory?.item !== menuText.SPIRITS && (
                  <Grid item>
                    <AppButton variant="contained" onClick={() => setReorderCategoriesOpen(true)}>
                      Reorder Categories
                    </AppButton>
                  </Grid>
                )}
                {linkCategory?.item === menuText.SPIRITS && (
                  <Grid item sx={{ position: "relative" }}>
                    <AppButton variant="contained" onClick={handleImportSpirit}>
                      Import Spirit
                    </AppButton>
                    {linkCategory?.item === menuText.SPIRITS &&
                      !!SpiritSubMenu?.[0]?.dmv_total_count && (
                        <Grid item sx={{ top: "6px" }} className={classes.ellipse_gold}>
                          {SpiritSubMenu?.[0]?.dmv_total_count}
                        </Grid>
                      )}
                  </Grid>
                )}
                <Grid item>
                  <Grid sx={{ position: "relative" }}>
                    <AppButton onClick={handleRouting}>
                      <CreateIcon
                        sx={(theme) => ({ color: theme.palette.secondary.main })}
                        className="me-2"></CreateIcon>
                      Edit Menu
                    </AppButton>
                  </Grid>
                </Grid>
              </Grid>
            </Header>
          </Col>
        </Row>
        <Row>
          <Col lg="12">
            <MenuNavBar activeTab={linkCategory?.item} subCategory={menuSubCategory?.[0]?.name} />
          </Col>
        </Row>
        {(linkCategory?.item === menuText.DINNER ||
          linkCategory?.item === menuText.LUNCH ||
          linkCategory?.item === menuText.BRUNCH ||
          linkCategory?.item === menuText.BREAKFAST ||
          linkCategory?.item === menuText.SPECIALS) && (
          <Row className="mt-4">
            <Col lg="12">
              <SubMenuBar activeTab={linkCategory?.category} menu={menuSubCategory} />
            </Col>
          </Row>
        )}
        {linkCategory?.item === menuText.SPIRITS && (
          <Row className="mt-4">
            <Col lg={12}>
              <SpiritsSubMenuBar isCMS={true} activeTab={menuCategory?.name} />
            </Col>
          </Row>
        )}
        <Row className="mt-4">
          <Col lg="4">
            <SearchTextField
              id="search"
              name="search"
              value={searchValue}
              onChange={handleSearchField}
              fullWidth
              type="search"
              placeholder="Search menu items or ingredients"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      backgroundColor: theme.palette.primary.main
                    }}>
                    <SearchIcon htmlColor={`${theme.palette.text.secondary}`} />
                  </InputAdornment>
                )
              }}
              style={{
                border: `1px solid ${theme.palette.text.secondary}`,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 6
              }}
            />
          </Col>
        </Row>
      </Container>
      {linkCategory?.item !== menuText.BARMENU &&
        linkCategory?.item !== menuText.SPIRITS &&
        linkCategory?.item !== menuText.WINEBOTTLE &&
        linkCategory?.item !== menuText.WINEBAR && (
          <Container fluid className="p-0 mt-4">
            {menuItems?.length > 0 ? (
              <MenuDndBoard
                items={menuItems}
                getId={(c) => c.food_category_id}
                onDragEnd={makeListDragEndHandler(menuItems, setMenuItems, linkCategory?.item)}
                renderCard={(menuItem) => (
                  <MenuListContainer
                    data={menuItem}
                    droppableId={String(menuItem.food_category_id)}
                    dragEnabled={!searchValue && !debouncedSearchTerm}
                    setMenuItemsModal={setMenuItemsModal}
                    setIsEditModalItem={setIsEditModalItem}
                  />
                )}
              />
            ) : (
              <Typography>
                {searchValue
                  ? "No items found matching your search"
                  : isLoading
                  ? "Please wait, we are fetching the menu items..."
                  : "No Data Found"}
              </Typography>
            )}
          </Container>
        )}
      {linkCategory?.item === menuText.BARMENU && (
        <Container fluid className="p-0 mt-4">
          {barItems?.length > 0 ? (
            <MenuDndBoard
              items={barItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                barItems,
                setBarItems,
                MEAL_PERIOD_API[menuText.BARMENU]
              )}
              renderCard={(menuItem) => (
                <BarListItems
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                  setMenuItemsModal={setMenuItemsModal}
                  setIsEditModalItem={setIsEditModalItem}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          )}
        </Container>
      )}
      {linkCategory?.item === menuText.WINEBAR && (
        <Container fluid className="p-0 mt-4">
          {wineItems?.length > 0 ? (
            <MenuDndBoard
              items={wineItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                wineItems,
                setWineItems,
                MEAL_PERIOD_API[menuText.WINEBAR]
              )}
              renderCard={(menuItem) => (
                <WineListItems
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          )}
        </Container>
      )}
      {linkCategory?.item === menuText.WINEBOTTLE && (
        <Container fluid className="p-0 mt-4">
          {wineItems?.length > 0 ? (
            <MenuDndBoard
              items={wineItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                wineItems,
                setWineItems,
                MEAL_PERIOD_API[menuText.WINEBOTTLE]
              )}
              renderCard={(menuItem) => (
                <WineBottleListItems
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          )}
        </Container>
      )}
      {linkCategory?.item === menuText.SPIRITS && (
        <>
          <Grid item sx={{ maxWidth: "50%" }}>
            {SpiritSubMenu?.map(
              (foodList, i) =>
                foodList?.id === menuCategory?.name &&
                (foodList?.description ||
                  foodList?.image_url ||
                  foodList?.unique_facts?.length > 0) && (
                  <DMV_SpiritSummary key={i} isEdit={false} foodList={foodList} isCMS={true} />
                )
            )}
          </Grid>
          <Container fluid className="p-0 mt-4">
            <div className={classes.spiritContainer}>
              {spiritItems?.length > 0 ? (
                spiritItems?.map((menuItem, idx) => {
                  return (
                    <SpiritsMenuListContainer
                      data={menuItem}
                      key={idx}
                      setMenuItemsModal={setMenuItemsModal}
                      setIsEditModalItem={setIsEditModalItem}></SpiritsMenuListContainer>
                  )
                })
              ) : (
                <Typography>
                  {searchValue ? "No items found matching your search" : "No Data Found"}
                </Typography>
              )}
            </div>
          </Container>
        </>
      )}
      <CommonModal
        open={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        hideAction={true}
        maxWidth="sm">
        <Box sx={{ padding: { xs: 3, md: 4 } }}>
          <Typography variant="h2" textAlign="center">
            Upload Status
          </Typography>
          <Box sx={{ mt: 4 }}>
            <Typography variant="body1" textAlign="center" color={theme.palette.text.secondary}>
              The previous upload is under process, please wait...
            </Typography>
          </Box>
        </Box>
      </CommonModal>
      <ReorderCategoriesModal
        open={reorderCategoriesOpen}
        onClose={() => setReorderCategoriesOpen(false)}
        categories={getCurrentCategories()}
        onSave={handleCategoryReorderSave}
      />
    </Fragment>
  )
}

export default Menu
